<template>
  <div class="notice-manage-main">
    <div class="search-main">
      <el-row type="flex" justify="space-between">
        <div>
          <el-button @click="releaseNotice()" type="primary"
            >新增</el-button
          >
        </div>

        <div>
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="公告标题">
              <el-input @change="_change()" 
                v-model="searchForm.msgTitle"
                placeholder="消息标题"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item label="发布时间">
              <el-date-picker @change="_change()" 
                v-model="searchForm.salaryMonthRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                value-format="YYYY-MM-DD"
                style="margin-right: 15px; width: 250px"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-right: 20px">
              <el-button @click="query()" type="primary">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>

    <div class="table-main">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        stripe
        height="calc(100% )"
        border
        style="width: 100%"
      >
        <el-table-column label="序号" width="55" type="index"></el-table-column>
        <el-table-column prop="title" label="公告标题" min-width="180">
        </el-table-column>
        <el-table-column label="是否显示" min-width="180" prop="isShow">
          <template #default="scope">
            <el-tag :type="scope.row.isShow == true ? 'success' : 'danger'">{{
              scope.row.isShow == true ? "已发布" : "未发布"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="creatTimeString"
          label="发布时间"
          min-width="180"
        >
        </el-table-column>
        <el-table-column prop="createUserName" label="发布人员" min-width="180">
        </el-table-column>
        <el-table-column
          fixed="right"
          prop="isShow"
          label="操作"
          min-width="180"
        >
          <template #default="scope">
            <el-button
              type="text"
              v-if="scope.row.isShow == true"
              @click="cancel(scope.row)"
              >取消公告</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.isShow == false"
              @click="release(scope.row)"
              >发布公告</el-button
            >
            <el-button
              type="text"
              @click="editNotice(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" style="color: red" @click="deleteNotice(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pages-main">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
      >
      </el-pagination>
    </div>
    <ReleaseNotice
      @scarch="noticeListQuery()"
      v-model="releaseNoticeDrawer"
      :title="modelTitel"
      ref="getReleaseNotice"
    />
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { r,getNoticeList,releaseAndcancelNotice,deleteNoticeList } from "@/api/notice/index";
import ReleaseNotice from "./ReleaseNotice";
export default {
  components: { ReleaseNotice },
  data() {
    return {
      //查询部分
      searchForm: {
        msgTitle: "", //公告标题
        salaryMonthRange: [], //时间戳
      },
      tableData: [], //表格内容
      //分页对象
      currentPage: 1, //当前页
      pageSize: 20, //每页条数
      pageTotal: 0, //共条数

      releaseNoticeDrawer: false, //抽屉
      modelTitel: "发布公告", //抽屉标题
      //提交数据
      params: {
        pageNo: 1,
        length: 20,
        startDate: "",
        endDate: "",
        title: "",
      },
    };
  },
  mounted() {
    this.noticeListQuery();
  },
  methods: {
    //发生修改
    _change(){
      this.noticeListQuery();
    },
    //通知公告操作
    noticeOperation(params,operationData){
      params.isShow=operationData
      releaseAndcancelNotice(params)
          .then(({ data }) => {
            if (data && data.status == true) {
              ElMessage({
                message: "操作成功",
                type: "success",
              });
            } else {
              ElMessage({
                message: data.msg,
                type: "warning",
              });
            }
          })
          .catch((_) => {});
    },
    //编辑
    editNotice(val){
      this.releaseNoticeDrawer = true;
      this.$refs.getReleaseNotice.editNoticeTest(val.id,val.isShow)
    },
    //取消公告
    cancel(val) {
      this.$confirm('确定要执行取消操作？', '提示').then(_ => {
        this.noticeOperation(val,false)
      })
    },
    //发布公告
    release(val) {
      this.$confirm('确定要执行发布操作？', '提示').then(_ => {
        this.noticeOperation(val,true)
      })
      
    },
    //删除公告
    deleteNotice(val){
      let that=this
      this.$confirm('确定要执行删除操作？', '提示').then(_ => {
        deleteNoticeList(val.row.id).then(({ data }) => {
            if (data && data.status == true) {
              ElMessage({
                message: "删除成功",
                type: "success",
              });
              that.tableData.splice(val.$index,1)
              that.pageTotal=that.pageTotal-1
            } else {
              ElMessage({
                message: data.msg,
                type: "warning",
              });
            }
          })
        .catch((_) => {});
      }).catch(_ => {});
      
    },
    //公告列表查询
    noticeListQuery() {
      let that = this;
      if (that.searchForm.salaryMonthRange.length > 0) {
        that.params.startDate = that.searchForm.salaryMonthRange[0];
        that.params.endDate = that.searchForm.salaryMonthRange[1];
      }
      that.params.pageNo = that.currentPage;
      that.params.length = that.pageSize;
      that.params.title = that.searchForm.msgTitle;
      getNoticeList(that.params)
        .then(({ data }) => {
          that.tableData = data.data;
          that.pageTotal = data.page.totalRecords;
          that.currentPage = data.page.pageNo;
        })
        .catch((_) => {});
    },
    //`每页 ${val} 条`
    handleSizeChange(val) {
      this.pageSize = val;
      this.noticeListQuery();
    },
    //`当前页: ${val}`
    handleCurrentChange(val) {
      this.currentPage = val;
      this.noticeListQuery();
    },
    //抽屉逻辑
    releaseNotice() {
      this.releaseNoticeDrawer = true;
    },
    //查询
    query() {
      this.noticeListQuery();
    },
  },
};
</script>

<style lang="scss" scoped>
.notice-manage-main {
  width: 100%;
  height: 100%;
  .search-main {
    padding: 10px;
    .el-form-item {
      margin-bottom: 0px;
    }

    > div:first-child {
      display: flex;
      align-items: center;
      > div:first-child {
        text-align: center;
        margin-right: 15px;
        .el-button {
          margin-left: 15px;
        }
      }
      & + div {
        .el-button {
          margin-left: 15px;
        }
      }
    }
  }
  .table-main {
    padding: 10px;
    height: calc(100% - 130px);
  }
  .pages-main {
    padding: 10px;
  }
}
</style>